// Generated with util/create-component.js
import AlertDialogue from './AlertDialogue';

export default AlertDialogue;
